import { Directive, HostListener, inject, Input } from '@angular/core';
import { GoogleTagManagerService } from '@app/services/google-tag-manager.service';

@Directive({
  selector: '[appGtmClick]',
  standalone: true,
})
export class GtmClickDirective {
  @Input({ required: true })
  public layer!: object;

  private readonly _googleTagManagerService = inject(GoogleTagManagerService);

  @HostListener('click')
  public onClick(): void {
    this._googleTagManagerService.gtag('event', 'conversion', this.layer);
  }
}
